import { z } from "zod";

/** Réglages SMTP éditables par l'admin. `smtpPass` omis/vide = mot de passe inchangé. */
export const smtpSettingsSchema = z.object({
  smtpHost: z.string().max(255).optional().or(z.literal("")),
  smtpPort: z.coerce.number().int().min(1).max(65535).optional(),
  smtpUser: z.string().max(255).optional().or(z.literal("")),
  smtpPass: z.string().max(255).optional(),
  smtpSecure: z.boolean().optional(),
  mailFrom: z.string().max(254).optional().or(z.literal("")),
  mailFromName: z.string().max(120).optional().or(z.literal("")),
});
export type SmtpSettingsInput = z.infer<typeof smtpSettingsSchema>;

export const sendTestEmailSchema = z.object({ to: z.string().email() });
